<sm-title-bar [pageTitle]="'Customer details'" [back]="true">
</sm-title-bar>
<mat-dialog-content class="cus_view_details" *ngIf="!loader && customerData.length > 0">
  <div class="customer_view_details">
    <div class="member_profile">
      <div class="opert_section">
        <button
          mat-icon-button
          [matMenuTriggerFor]="menu2"
          class="more-button"
          aria-label="More options"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu2="matMenu">
          <button mat-menu-item (click)="createInvoice(customerData[0])" *ngIf="isAccessForEmployeeInvoice">
            <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
            <span>Create invoice</span>
          </button>
          <button mat-menu-item (click)="openAllBookings(customerData[0])">
            <mat-icon>list</mat-icon>
            <span>{{ "customers.op1" | translate }}</span>
          </button>
          <button mat-menu-item (click)="openAllPayments(customerData[0])">
            <mat-icon class="material-icons-outlined">receipt</mat-icon>
            <span>See all payments</span>
          </button>
          <button mat-menu-item (click)="openDueBookings(customerData[0])">
            <mat-icon class="material-icons-outlined">pending_actions</mat-icon>
            <span>See due bills/invoices</span>
          </button>
             <button mat-menu-item (click)="openwallemoney(customerData[0])">
            <mat-icon class="material-icons-outlined">wallet</mat-icon>
            <span>Wallet money</span>
          </button>

            <button mat-menu-item (click)="openrewardpoint(customerData[0])">
            <mat-icon class="material-icons-outlined">card_giftcard</mat-icon>
            <span>Reward points</span>
          </button>
          <button mat-menu-item >
             <mat-icon class="material-icons-outlined">notification_add</mat-icon>
              <span>Service reminders</span>
          </button>
          <button
            mat-menu-item
            (click)="openPaymentIntimation(customerData[0])"
            *ngIf="customerData[0].total_due > 0 && isOwner"
          >
            <mat-icon class="material-icons-outlined">share</mat-icon>
            <span>{{ "customers.op3" | translate }}</span>
          </button>
          <button mat-menu-item (click)="editCustomer(customerData[0])" *ngIf="isOwner">
            <mat-icon class="material-icons-outlined">edit</mat-icon>
            <span>Edit Customer</span>
          </button>
          <button mat-menu-item (click)="deleteCustomer(customerData[0])" *ngIf="isOwner">
            <mat-icon class="material-icons-outlined">delete</mat-icon>
            <span>Delete Customer</span>
          </button>
        </mat-menu>
      </div>
      <div class="bgt_colorkk"></div>
      <img
        [src]="customerData[0].image_thumb_url"
        onerror="this.src='../../../../../assets/images/user-avatar.svg'"
        alt=""
      />
      <div class="customer_heading">
        <h3>{{ customerData[0].name }}</h3>
        <p style="margin-bottom: 5px;">{{ customerData[0].cust_phone }}</p>
        <p>
          {{
            customerData[0]?.email &&
            customerData[0]?.email != "" &&
            customerData[0]?.email != "null"
              ? customerData[0]?.email
              : "No email added"
          }}
        </p>
      </div>
      <div
        class="chatnow_btn_sed"
        *ngIf="
          customerData[0].profile_hash_id &&
          customerData[0].profile_hash_id != 'null' &&
          customerData[0].profile_hash_id != '---'
        "
      >
        <button mat-flat-button (click)="openMessages(customerData[0])">
          Chat now
          <!-- <mat-icon>send</mat-icon> -->
        </button>
      </div>
    </div>
    <div class="hold_enrt">
      <div
        class="customer_review_section"
        style="
          margin-top: 30px;
          border-bottom: 1px solid #ddd;
          margin-bottom: 25px;
        "
      >
        <div class="sub_one sub_margin openchan">
          <div class="sub_one_cont">
            <div>
              <span class="material-icons icon_mat"> transgender </span>
            </div>
            <div class="entity_detail make_text_grey">Gender</div>
          </div>
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 15px"
            >
              {{ customerData[0].gender1 }}
            </div>
          </div>
        </div>

        <div class="sub_one sub_margin">
          <div class="sub_one_cont">
            <div>
              <span class="material-icons icon_mat material-symbols-outlined"> calendar_month </span>
            </div>
            <div class="entity_detail make_text_grey">DOB</div>
          </div>
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 15px"
            >
              {{ customerData[0].dob && customerData[0].dob != "---" ? (customerData[0].dob | date) : "---" }}
            </div>
          </div>
        </div>
      </div>
      <div class="customer_review_section" style="border-bottom: 1px solid #ddd; margin-bottom: 25px">
        <div class="sub_one sub_margin openchan">
          <div class="sub_one_cont">
            <div>
              <span class="material-icons icon_mat material-symbols-outlined"> work_history </span>
            </div>
            <div class="entity_detail make_text_grey">Last booking</div>
          </div>
          <div class="sub_one_cont main_text">
            <div class="entity_detail">
              <div
                class="entity_detail"
                style="margin-left: 34px; font-size: 15px"
              >
                {{
                  customerData[0].last_booking_date && customerData[0].last_booking_date != "---"
                    ? (customerData[0].last_booking_date | date)
                    : "---"
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="sub_one sub_margin">
          <div class="sub_one_cont">
            <div>
              <span class="material-icons icon_mat"> payments </span>
            </div>
            <div class="entity_detail make_text_grey">payment due</div>
          </div>
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 15px"
            >
              {{ customerData[0].currency_symbol }}{{ customerData[0].total_due.toFixed(2) }}
            </div>
          </div>
        </div>
      </div>

      <!-- wallet money section start -->
     <div class="customer_review_section" style="border-bottom: 1px solid #ddd; margin-bottom: 25px">
        <div class="sub_one sub_margin openchan">
          <div class="sub_one_cont">
            <div>
              <span class="material-icons icon_mat"> card_giftcard </span>
            </div>
            <div class="entity_detail make_text_grey">Wallet money</div>
          </div>
          <div class="sub_one_cont main_text">
            <div class="entity_detail">
              <div class="entity_detail"  style="margin-left: 34px; font-size: 15px">
               ₹5,422.00
              </div>
            </div>
          </div>
        </div>
        <div class="sub_one sub_margin">
          <div class="sub_one_cont">
            <div>
              <span class="material-icons icon_mat"> emoji_events </span>
            </div>
            <div class="entity_detail make_text_grey">Reward points</div>
          </div>
          <div class="sub_one_cont main_text">
            <div class="entity_detail" style="margin-left: 34px; font-size: 15px">
             400
            </div>
          </div>
        </div>
      </div>
      <!--end section  -->
      <div class="customer_review_section">
        <div class="sub_one sub_margin openchan" style="border-right: none;     width: 100% !important;">
          <div class="sub_one_cont">
            <div>
              <span class="material-icons icon_mat"> notes </span>
            </div>
            <div class="entity_detail make_text_grey">Notes</div>
          </div>
          <div class="sub_one_cont main_text">
            <div class="entity_detail">
              <div
                class="entity_detail"
                style="margin-left: 34px; font-size: 15px"
              >
                {{
                  customerData[0].notes &&
                  customerData[0].notes != "---" &&
                  customerData[0].notes != "" &&
                  customerData[0].notes != "null"
                    ? customerData[0].notes
                    : "No notes added"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
